// assets
import {
  BankOutlined,
  ContactsOutlined,
  DollarCircleOutlined,
  DollarOutlined,
  FileAddOutlined,
  ProfileOutlined,
  TransactionOutlined,
  UnorderedListOutlined
} from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';
import { Rights } from '../graphql/types';
import OffersIcon from '../components/menu-icons/Offers';
import TransactionsMenuIcon from '../components/menu-icons/TransactionsMenuIcon';

// icons
const icons = {
  BankOutlined,
  DollarCircleOutlined,
  DollarOutlined,
  ProfileOutlined,
  TransactionOutlined,
  FileAddOutlined,
  UnorderedListOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const merchants: NavItemType = {
  id: 'merchants',
  type: 'group',
  children: [
    {
      id: 'merchants-cash-advances',
      title: 'Cash Advances',
      type: 'item',
      url: '/merchants/mcas',
      icon: { anticon: icons.DollarCircleOutlined },
      oneOfRights: [
        Rights.IsSuperAdmin,
        Rights.IsIsoManager,
        Rights.IsUnderwriter,
        Rights.IsInvestor,
        Rights.IsMerchant,
        Rights.IsFunder,
        Rights.IsLegal,
        Rights.IsCollection,
        Rights.IsUser
      ]
    },
    {
      id: 'mac-profile',
      title: 'Cash Advance',
      type: 'item',
      hidden: true,
      url: '/merchants/mca',
      icon: { anticon: icons.ProfileOutlined }
    },
    {
      id: 'transactions',
      title: 'Transactions',
      type: 'item',
      url: '/transactions',
      icon: { anticon: TransactionsMenuIcon },
      rights: [Rights.IsSuperAdmin]
    },
    {
      id: 'funding-pipeline',
      title: 'Funding Pipeline',
      type: 'item',
      url: '/funding-pipeline',
      icon: { anticon: icons.DollarOutlined },
      oneOfRights: [
        Rights.IsSuperAdmin,
        Rights.IsUnderwriter,
        Rights.IsPreUnderwriter,
        Rights.IsIsoManager,
        Rights.IsBroker
      ]
    },
    {
      id: 'offers',
      title: 'Apps & Offers',
      type: 'item',
      url: '/offers',
      icon: { anticon: OffersIcon },
      oneOfRights: [
        Rights.IsSuperAdmin,
        Rights.IsIsoManager,
        Rights.IsPreUnderwriter,
        Rights.IsUnderwriter,
        Rights.IsSubmissionAdmin
      ]
    },
    {
      id: 'applications',
      title: 'Submissions',
      type: 'item',
      url: '/applications',
      icon: { anticon: icons.FileAddOutlined },
      oneOfRights: [
        Rights.IsSuperAdmin,
        Rights.IsIsoManager,
        Rights.IsPreUnderwriter,
        Rights.IsUnderwriter,
        Rights.IsSubmission,
        Rights.IsSubmissionAdmin
      ]
    },
    {
      id: 'investors-list',
      title: 'Investors',
      type: 'item',
      url: '/investors-list',
      icon: { anticon: ContactsOutlined },
      rights: [Rights.IsSuperAdmin]
    }
  ]
};

export default merchants;
